import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useCurrency } from "@/contexts/CurrencyContext";
import { cn } from "@/lib/utils";

interface CurrencySelectorProps {
  /** Controlled mode — omit to bind to the user's display currency. */
  value?: string;
  onChange?: (code: string) => void;
  label?: string;
  className?: string;
  triggerClassName?: string;
  compact?: boolean;
}

export function CurrencySelector({
  value,
  onChange,
  label,
  className,
  triggerClassName,
  compact = false,
}: CurrencySelectorProps) {
  const { currency, setCurrency, currencies } = useCurrency();
  const active = value ?? currency;

  const handle = (code: string) => {
    if (onChange) onChange(code);
    else setCurrency(code as any);
  };

  return (
    <div className={cn("flex items-center gap-2", className)}>
      {label ? <span className="text-xs text-muted-foreground">{label}</span> : null}
      <Select value={active} onValueChange={handle}>
        <SelectTrigger className={cn(compact ? "h-8 w-[110px] text-xs" : "h-9 w-[180px]", triggerClassName)}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent className="max-h-72">
          {currencies.map((c) => (
            <SelectItem key={c.code} value={c.code}>
              <span className="mr-1">{c.symbol}</span>
              {compact ? c.code : `${c.code} — ${c.name}`}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

export default CurrencySelector;
